/* CVF-042-AB */
(function () {
  'use strict';

  var BODY_CLASS = 'cvf-042-ab-active';
  var PROMISE_CLASS = 'cvf-042-ab__promise-banner';
  var METAFIELD_CLASS = 'cvf-042-ab__metafield-message';
  var VISIBLE_CLASS = 'is-visible';

  var CONFIG = {
    cartDrawerSelector: '#cart-drawer-data',
    sectionId: 'cart-drawer',
    promiseMessage: 'Your performance upgrade is in the cart',
    cartItemSelectors: '.upcart-product-item, .upcart-public-component-product-tile',
    debounceDelay: 150,
    eligibleProductIds: [
      '7573898559700',
      '7689012314324',
      '7794578358484',
      '8755993739476',
      '8111817523412',
      '2526422106230',
      '7330835923156',
      '2544877535350',
      '7830954639572',
      '4396352143478',
    ],
  };

  var cachedCartItems = null;
  var cartObserverStarted = false;

  function isVariantActive() {
    return document.body.classList.contains(BODY_CLASS);
  }

  function debounce(func, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  function getConfig() {
    var configNode = document.getElementById('cvf-042-ab-config');
    if (!configNode) return null;

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function getConfigMessage() {
    var parsed = getConfig();
    if (parsed && parsed.promiseMessage) return parsed.promiseMessage;
    return CONFIG.promiseMessage;
  }

  function getEligibleProductIds() {
    var parsed = getConfig();
    var ids =
      parsed && Array.isArray(parsed.eligibleProductIds)
        ? parsed.eligibleProductIds
        : CONFIG.eligibleProductIds;

    return new Set(ids.map(function (id) {
      return String(id);
    }));
  }

  function isEligibleProduct(productId) {
    if (!productId) return false;
    return getEligibleProductIds().has(String(productId));
  }

  function formatMetafieldMessage(message) {
    if (!message) return '';
    return message.replace(/^ESTIMATED SHIP DATE:\s*/i, '').trim();
  }

  async function getCartWithMetafields() {
    try {
      var response = await fetch('/cart?section_id=' + CONFIG.sectionId);
      if (!response.ok) return null;

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cartData = doc.querySelector(CONFIG.cartDrawerSelector);
      if (!cartData) return null;

      var itemsAttr = cartData.getAttribute('data-cart-items');
      if (!itemsAttr) return null;

      return JSON.parse(itemsAttr);
    } catch (error) {
      return null;
    }
  }

  function findCartItemElements() {
    return document.querySelectorAll(CONFIG.cartItemSelectors);
  }

  function getVariantIdFromElement(element) {
    var elementId = element.getAttribute('id');
    if (elementId && elementId.indexOf(':') !== -1) {
      return elementId.split(':')[0];
    }

    var productLink = element.querySelector('a[href*="?variant="]');
    if (productLink) {
      var href = productLink.getAttribute('href') || '';
      var match = href.match(/[?&]variant=(\d+)/);
      if (match) return match[1];
    }

    var quantityInput = element.querySelector('[data-quantity-variant-id]');
    if (quantityInput) {
      return quantityInput.getAttribute('data-quantity-variant-id');
    }

    return null;
  }

  function removeControlMessages() {
    document.querySelectorAll('.out-of-stock-message').forEach(function (node) {
      node.remove();
    });
  }

  function hideControlSuccessBanner() {
    document
      .querySelectorAll(
        '.upcart-announcement, .upcart-public-announcement, .cart-top-message-wraper'
      )
      .forEach(function (node) {
        node.setAttribute('hidden', '');
      });
  }

  function getCartHeader() {
    return document.querySelector('.upcart-header, .upcart-public-header');
  }

  function unwrapLegacyCartTop() {
    var topBlock = document.querySelector('.cvf-042-ab__cart-top');
    if (!topBlock) return;

    var header = topBlock.querySelector('.upcart-header, .upcart-public-header');
    var banner = topBlock.querySelector('.' + PROMISE_CLASS);

    if (header && topBlock.parentNode) {
      topBlock.parentNode.insertBefore(header, topBlock);
      if (banner && !header.contains(banner)) {
        header.appendChild(banner);
      }
    }

    topBlock.remove();
  }

  function updateCartCloseIcon() {
    if (!isVariantActive()) return;

    var header = getCartHeader();
    if (!header) return;

    var closeBtn = header.querySelector(
      '.upcart-header-close-button, .upcart-public-header__close-button'
    );
    if (!closeBtn || closeBtn.querySelector('[data-cvf-042-ab-close]')) return;

    var template = document.getElementById('cvf-042-ab-close-icon');
    if (!template || !template.content) return;

    var sourceIcon = template.content.querySelector('svg');
    if (!sourceIcon) return;

    var icon = sourceIcon.cloneNode(true);
    icon.setAttribute('data-cvf-042-ab-close', 'true');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.classList.add('upcart-header-close-button-icon', 'cvf-042-ab__close-icon');

    closeBtn.innerHTML = '';
    closeBtn.appendChild(icon);
  }

  function updatePromiseBanner(hasItems) {
    unwrapLegacyCartTop();

    var header = getCartHeader();
    if (!header) return;

    updateCartCloseIcon();

    var banner = header.querySelector('.' + PROMISE_CLASS);
    if (!banner) {
      banner = document.querySelector('.' + PROMISE_CLASS);
      if (!banner) {
        banner = document.createElement('div');
        banner.className = PROMISE_CLASS;
        banner.setAttribute('role', 'status');
      }
      header.appendChild(banner);
    } else if (banner.parentElement !== header) {
      header.appendChild(banner);
    }

    var textNode = banner.querySelector('.cvf-042-ab__promise-banner-text');
    if (!textNode) {
      banner.textContent = '';
      textNode = document.createElement('p');
      textNode.className = 'cvf-042-ab__promise-banner-text';
      banner.appendChild(textNode);
    }

    textNode.textContent = getConfigMessage();
    hideControlSuccessBanner();

    if (hasItems) {
      banner.classList.add(VISIBLE_CLASS);
    } else {
      banner.classList.remove(VISIBLE_CLASS);
    }
  }

  function injectMetafieldMessages(cartItems) {
    removeControlMessages();

    if (!cartItems || cartItems.length === 0) {
      document.querySelectorAll('.' + METAFIELD_CLASS).forEach(function (node) {
        node.remove();
      });
      updatePromiseBanner(false);
      return;
    }

    updatePromiseBanner(true);

    var cartItemElements = findCartItemElements();
    var matchedVariantIds = new Set();

    cartItemElements.forEach(function (element) {
      var variantId = getVariantIdFromElement(element);
      if (!variantId) return;

      var cartItem = cartItems.find(function (item) {
        return String(item.variant_id) === String(variantId) || String(item.id) === String(variantId);
      });

      if (!cartItem) return;

      if (!isEligibleProduct(cartItem.product_id)) {
        var ineligibleMessage = element.querySelector('.' + METAFIELD_CLASS);
        if (ineligibleMessage) ineligibleMessage.remove();
        return;
      }

      matchedVariantIds.add(String(variantId));

      var message = typeof cartItem.out_of_stock_message === 'string'
        ? formatMetafieldMessage(cartItem.out_of_stock_message.trim())
        : '';

      var messageElement = element.querySelector('.' + METAFIELD_CLASS);

      if (!message) {
        if (messageElement) messageElement.remove();
        return;
      }

      if (!messageElement) {
        messageElement = document.createElement('div');
        messageElement.className = METAFIELD_CLASS;
        var textNode = document.createElement('p');
        textNode.className = 'cvf-042-ab__metafield-message-text';
        messageElement.appendChild(textNode);
        element.appendChild(messageElement);
      }

      var metafieldTextNode = messageElement.querySelector('.cvf-042-ab__metafield-message-text');
      if (!metafieldTextNode) {
        metafieldTextNode = document.createElement('p');
        metafieldTextNode.className = 'cvf-042-ab__metafield-message-text';
        messageElement.textContent = '';
        messageElement.appendChild(metafieldTextNode);
      }

      metafieldTextNode.textContent = message;
      messageElement.classList.add(VISIBLE_CLASS);
    });

    document.querySelectorAll('.' + METAFIELD_CLASS).forEach(function (node) {
      if (cartItemElements.length === 0) return;

      var parentItem =
        node.closest('.upcart-product-item') ||
        node.closest('.upcart-public-component-product-tile');
      if (!parentItem) {
        node.remove();
        return;
      }

      var variantId = getVariantIdFromElement(parentItem);
      if (!variantId || !matchedVariantIds.has(String(variantId))) {
        node.remove();
      }
    });
  }

  function injectFromCache() {
    if (!cachedCartItems) return;
    injectMetafieldMessages(cachedCartItems);
  }

  function startCartObserver() {
    if (cartObserverStarted) return;

    var cartRoot = document.querySelector('.upcart-cart');
    if (!cartRoot) return;

    cartObserverStarted = true;

    var observer = new MutationObserver(function () {
      if (!isVariantActive() || !cachedCartItems) return;
      requestAnimationFrame(injectFromCache);
    });

    observer.observe(cartRoot, { childList: true, subtree: true });
  }

  async function fetchAndInjectCartItems() {
    if (!isVariantActive()) return;

    hideControlSuccessBanner();

    var cartItems = await getCartWithMetafields();
    if (!cartItems) return;

    cachedCartItems = cartItems;
    injectMetafieldMessages(cartItems);
    startCartObserver();
  }

  function scheduleFetchAndInject() {
    debouncedFetchAndInject();
  }

  async function updateCartVariant() {
    injectFromCache();
    await fetchAndInjectCartItems();
  }

  var debouncedFetchAndInject = debounce(fetchAndInjectCartItems, CONFIG.debounceDelay);

  window.cvf042AbRefresh = function () {
    if (!isVariantActive()) return;
    updateCartVariant();
  };

  function onCartDomChange() {
    if (!isVariantActive()) return;
    requestAnimationFrame(injectFromCache);
    scheduleFetchAndInject();
  }

  function initUpCartListeners() {
    if (typeof window.upcartSubscribeCartLoaded !== 'function') {
      setTimeout(initUpCartListeners, 500);
      return;
    }

    window.upcartSubscribeCartLoaded(onCartDomChange);
    window.upcartSubscribeCartUpdated(onCartDomChange);
    window.upcartSubscribeCartOpened(onCartDomChange);
    window.upcartSubscribeAddedToCart(onCartDomChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpCartListeners);
  } else {
    initUpCartListeners();
  }

  if (isVariantActive()) {
    updateCartVariant();
  }
})();
